import React, { useState } from 'react';
import { useFiltro } from '../../FiltroContext';
import {
  FilterContainer,
  FilterHeader,
  FilterTitle,
  FilterRow,
  CheckboxContainer,
  FullWidthButton,
} from './styles';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';

const TypeBoolean: React.FC = () => {
  const { isFilterBlock, handleSetNewValue, filter, removeFilter } =
    useFiltro();

  const [isChecked, setIsChecked] = useState(filter.des_valor === 'true');
  const [condition] = useState(filter.condicao);

  const onChange = () => {
    setIsChecked(!isChecked);
  };

  const handleSetValueFiltro = () => {
    handleSetNewValue({
      index: filter.index,
      des_nome: filter.des_nome,
      nome_bd: filter.nome_bd,
      condicao: condition,
      des_valor: isChecked ? 'true' : 'false',
      cod_tipo_dados: filter.cod_tipo_dados,
      cod_tipo_info: filter.cod_tipo_info,
      cod_campo: filter.cod_campo,
      isBlock: isFilterBlock,
      expressao_validacao: filter.expressao_validacao,
      listagem_info: filter.listagem_info,
      tipo_expressao: filter.tipo_expressao,
    });
  };

  return (
    <FilterContainer>
      {/* Header com título e botão de remover */}
      <FilterHeader>
        <FilterTitle>{filter.des_nome}</FilterTitle>
      </FilterHeader>

      {/* Linha do Checkbox */}
      <FilterRow>
        <CheckboxContainer>
          <input
            type="checkbox"
            checked={isChecked}
            onChange={onChange}
            step={1}
          />{' '}
          Marcado?
        </CheckboxContainer>
      </FilterRow>

      {/* Botão de Atualizar */}
      <FullWidthButton>
        <CustomButtonNovo
          type="button"
          onClick={handleSetValueFiltro}
          style={{ backgroundColor: '#0052CC' }}
          label="Atualizar"
        />
      </FullWidthButton>
    </FilterContainer>
  );
};

export default TypeBoolean;
